import { useEffect, useState } from "react"
import { Label } from "@inkblot-therapy/squid"

import {
  ValidationCSVData,
  ValidationResponse,
} from "../../types/ValidationResponse"

export const UploadResult = ({
  validationResponse,
}: {
  validationResponse: ValidationResponse
}) => {
  const { data } = validationResponse
  const [sortedData, setSortedData] = useState<ValidationCSVData[]>([])

  useEffect(() => {
    setSortedData(
      [...data].sort((a, b) => {
        const keyA = Object.keys(a)[0]
        const keyB = Object.keys(b)[0]
        if (a[keyA]?.order > b[keyB]?.order) {
          return 1
        } else {
          return -1
        }
      }),
    )
  }, [data])

  const renderField = (field: any) => {
    const key: any = Object.keys(field)[0]
    const subKey = field[key]

    return (
      <tbody key={key}>
        <tr className="border p-7">
          <th className="w-72 text-left text-sm text-gray-700 border p-5">
            <Label>{subKey?.prompt_en}</Label>
          </th>
          {subKey.errors.length > 0 ? (
            subKey.errors.map((error: string) => (
              <td className=" p-5" key={error}>
                <Label className="text-[#A71226]">{error}</Label>
              </td>
            ))
          ) : (
            <td className="text-gray-900 p-5">
              <Label className="font-medium">
                {subKey.value == null && "-"}
                {subKey.value !== "" && subKey.value}
              </Label>
            </td>
          )}
        </tr>
      </tbody>
    )
  }

  return (
    <>
      <div className="block">
        <table className="table-auto w-full border mt-5">
          {sortedData.map((field) => renderField(field))}
        </table>
      </div>
    </>
  )
}
